<template>
  <div class="default-template">
    <div class="default-template__ttl">{{ question.question }}</div>
    <div class="default-template__sub-ttl"></div>

    <div class="mail-template">
      <input
        type="email"
        placeholder="Your Email"
        v-model="answerText"
        @focus="error = false"
      />
      <span class="error" v-show="error">Email is not valid</span>
    </div>
    <div class="main__action">
      <button class="btn btn--grey" @click.prevent="back">Back</button>
      <button class="btn" @click.prevent="next">Next</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MailTemplate",
  props: {
    question: Object,
    answers: Object,
  },
  data() {
    return {
      error: false,
      answerText: "",
    };
  },
  watch: {
    question: {
      immediate: true,
      handler(val) {
        if (this.answers[val.id]) {
          this.answerText = this.answers[val.id].val;
        } else {
          this.answerText = "";
        }
      },
    },
  },
  methods: {
    validateEmail(email) {
      const re = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      return re.test(email);
    },
    next() {
      if (!this.validateEmail(this.answerText) || this.answerText === "") {
        this.error = true;
        return;
      }
      const answer = {
        id: this.question.id,
        val: this.answerText,
        ttl: this.question.question,
      };
      this.$emit("next", answer);
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>
